// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1a7Mw","OrderButton":"BuildControls_OrderButton__zZ7vM","enable":"BuildControls_enable__22b82"};